import React from 'react'
import ReactSelect from 'react-select';
import selectStyles from '../../../../ui/selectStyles.js';


const options = [
    { value: '18-24', label: '18 to 24' },
    { value: '25-34', label: '25 to 34' },
    { value: '35-44', label: '35 to 44' },
    { value: '45-54', label: '45 to 54' },
    { value: '55-65', label: '55 to 65' },
    { value: '65+', label: '65+' },
];



export default function AgeGroup(props) {
    const inputId = `field-${props.name}`;

    return (
        <div className="Select">
            <label className="TextField--label" htmlFor={inputId}>{props.label}</label>
            <div className={`Select--container${props.error ? " is-error" : ""}`}>
                <ReactSelect
                    inputId={inputId}
                    options={options}
                    value={props.selectAgeGroupData}
                    onChange={props.handleSelectChange}
                    styles={selectStyles}
                    placeholder="Select Age Group"
                    menuPortalTarget={document.body} // render menu outside
                    menuPosition="fixed"             // ensures correct placement
                />
            </div>
            {props.error && <p className="TextField--error">{props.errorMessage}</p>}
        </div>
    )
}
